
import {NewviewOaBaseApi} from "./NewviewOaBaseApi";


export class ContractInvoicePaymentApi extends NewviewOaBaseApi {

  public get ControllerName(): any {
    return 'contract-invoice-payment'
  }

}
